// extracted by mini-css-extract-plugin
export default {"maintenance":"MaintenancePage_maintenance__NOnz9","article":"MaintenancePage_article__epyb+","heading":"MaintenancePage_heading__yEI6r","text":"MaintenancePage_text__xMgun"};